import { useTheme } from '@emotion/react';
import { Picture } from '@icon-park/react';
import { cloneElement, memo, type ReactElement } from 'react';

import * as styles from './CardMedia.styles';

export type CardMediaProps = {
  /** Image src. If not provided, will use the icon. */
  imageSrc?: string;
  /** Alt text for the image. */
  altText?: string;
  /** Icon to display if no image is provided. */
  icon?: ReactElement;
};

export const CardMediaBase = ({
  imageSrc = null,
  altText = null,
  icon = <Picture />,
}: CardMediaProps) => {
  const theme = useTheme();

  return imageSrc ? (
    <img src={imageSrc} alt={altText} css={styles.image} />
  ) : (
    <div css={styles.cover}>
      <div css={styles.placeholder}>
        <div css={styles.placeholderImage}>
          {cloneElement(icon, {
            size: 50,
            fill: [theme.colors.primary[200], theme.colors.primary[50]],
          })}
        </div>
      </div>
    </div>
  );
};

CardMediaBase.displayName = 'CardCover';

export const CardMedia = memo(CardMediaBase);
